class ComponentProgramFAQ extends HTMLElement {
    constructor() {
        super();
        this.initAccordion('.question-accordion', true);
    }

    initAccordion (elem, option) {
        document.addEventListener('click', e => {
            if (!e.target.matches(elem + ' .question-btn')) return;
            else {
                if (!e.target.parentElement.classList.contains('active')) {
                    if (option == true) {
                        var elementList = document.querySelectorAll(elem + ' .question-container');
                        Array.prototype.forEach.call(elementList, function (e) {
                            e.classList.remove('active');
                        });
                    }
                    e.target.parentElement.classList.add('active');
                } else {
                    e.target.parentElement.classList.remove('active');
                }
            }
        });
    }
}

customElements.define('program-faq', ComponentProgramFAQ);